import { useContext } from 'react';

import ClubBaseInfoData from './ClubBaseInfoData';
import { ClubBaseInfoStateContext } from './ClubBaseInfoContextProvider';

const useClubBaseInfoData = () => {
  const [clubBaseInfoState, setBaseInfoState] = useContext(ClubBaseInfoStateContext);

  const getClubBaseInfo = (usasClubId) => {
    return ClubBaseInfoData.getClubBaseInfoData(usasClubId, clubBaseInfoState, setBaseInfoState);
  };

  return {
    clubBaseInfoState,
    getClubBaseInfo
  };
};

export default useClubBaseInfoData;